'use strict';
import React from 'react';

const PrintFooter = () => {
    return (
        <p className="col-xs-12 print-footer">© 2021 CBRE, Inc. All rights reserved. The information contained herein is subject to CBRE’s Terms and Conditions of Use. (https://forio.com/app/cbre/lease-calculator/terms.html) Without limiting such Terms and Conditions, no representation or warranty of any kind is made as to the accuracy, completeness, or fitness for any particular purpose of the estimates contained herein. You are solely responsible for independently verifying, and any reliance by you on the estimates provided on this website is at your own risk.</p>
    );
};
export default PrintFooter;